import appLoginView from './../app.login/appLoginModal.html';
import appLoginCtrl from './../app.login/appLoginCtrl';

import appChangePasswordView from './../app.change_password/appChangePassword.html';
import appChangePasswordCtrl from './../app.change_password/appChangePasswordCtrl';

export default function ($rootScope, $scope, $http, $timeout, $cookies, $state, $stateParams, $location, $uibModal, $firebaseAuth, $firebaseObject, contentTypes, CONFIG, FirebaseFactory) {
    'ngInject';

    $scope.contentTypesMenu = !!contentTypes ? contentTypes.items : [];
    $scope.firebaseFactory = FirebaseFactory;
    $scope.isLoaded = false;
    $scope.activeContextPageCss = "navbar-linkcontainer--link";
    $scope.activeContextArticleCss = "navbar-linkcontainer--link";

    let auth = $firebaseAuth();
    auth.$onAuthStateChanged((firebaseUser) => {
        $rootScope.isLogged = FirebaseFactory.isLogged(firebaseUser);

        if ($rootScope.isLogged) {
            $rootScope.firebaseUser.uid = firebaseUser.uid;
            let ref = FirebaseFactory.getUser(firebaseUser.uid);
            let obj = $firebaseObject(ref);
            obj.$loaded().then( () => {
                loadHeader();
            });
        }
    });


    $rootScope.$on('selectionMenu', (evt, args) => {
        let context = args.context;
        $timeout(()=> {
            if (context === 'page') {
                $scope.activeContextPageCss += " active";
                $scope.activeContextArticleCss = "navbar-linkcontainer--link";
            } else if (context === 'article') {
                $scope.activeContextPageCss = "navbar-linkcontainer--link";
                $scope.activeContextArticleCss += " active";
            } else {
                $scope.activeContextPageCss = "navbar-linkcontainer--link";
                $scope.activeContextArticleCss = "navbar-linkcontainer--link";
            }
        });
    });

    let loadHeader = () => {
        if (!!$rootScope.firebaseUser) {
            let ref = FirebaseFactory.getUser($rootScope.firebaseUser.uid);
            let obj = $firebaseObject(ref);
            obj.$loaded().then( () => {
                let keys = obj.hasOwnProperty('permissions') ? Object.keys(obj.permissions) : [];
                let tempArray = [];
                let endpoint = `entries?content_type=region&order=fields.title&sys.type[ne]=${(new Date()).valueOf()}`;
                let isAdmin = obj.isAdmin;
                $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint}`).then((data) => {
                    $scope.isLoaded = true;
                    $scope.regions = data.data.items;
                    $rootScope.allRegions = data.data.items;
                    $rootScope.regions = $scope.regions;
                    tempArray = $scope.regions;
                    if (!isAdmin) {
                        tempArray = [];
                        _.forEach($scope.regions, (region) => {
                            _.forEach(keys, (key) => {
                                if (key === region.sys.id) {
                                    tempArray.push(region);
                                }
                            });
                        });
                    }

                    $rootScope.regions = tempArray;
                    $scope.regions = $rootScope.regions;
                    localStorage.setItem('regions', JSON.stringify($scope.regions));
                    $scope.region = $scope.regions[0];
                    if (!!$stateParams.region) {
                        $scope.region = $rootScope.regions.filter( (regions) => {return regions.sys.id === $stateParams.region });
                        $scope.region = $scope.region.length > 0 ? $scope.region[0] : [];
                        $cookies.put('region', JSON.stringify($scope.region));
                    }
                    else if (!!$cookies.get('region')) {
                        let regions_user = $rootScope.regions.filter( (regions) => {return regions.fields.title === JSON.parse($cookies.get('region')).fields.title });
                        //Check if the region cached is compatible with the user
                        $scope.region = (regions_user.length > 0) ? JSON.parse($cookies.get('region')) : $scope.regions[0];

                        $rootScope.regions.filter( (regions) => {return regions === JSON.parse($cookies.get('region')) });
                    } else {
                        $cookies.put('region', JSON.stringify($scope.regions[0]));
                        $scope.region = $scope.regions[0];
                    }

                    console.warn('$stateParams', $stateParams.region, $scope.region, $cookies.get('region'),  JSON.parse(localStorage.getItem("regions")));
                }, (e) => {
                    $rootScope.raven.captureException(e);
                    $rootScope.raven.showReportDialog();
                });
            });
        }
    };


    /***
     * Select Region
     * @param value
     */
    $scope.selectedRegion = (value) => {
        $cookies.put('region', JSON.stringify(value));
        $scope.region = value;
        $timeout(()=> {
            $state.go('home', { 'region': $scope.region.sys.id });
        }, 100);
        //let path = $location.path().split('/')[1];
        //$state.go('home', { 'region': $scope.region.sys.id });
        /*if (path !== 'page' || path === 'article') {
            $state.reload();
        } else {
            $state.go(`^.list`);
            $timeout(()=> {
                $state.reload();
            }, 100);
        }*/
    };


    /***
     * Open Login Modal
     */
    $scope.openModalLogin = () => {
        let modalInstance = $uibModal.open({
            template: appLoginView,
            controller: appLoginCtrl,
            controllerAs: 'vm',
            resolve: {}
        });
    };

    /***
     * Open Change Password Modal
     */
    $scope.openModalChangePassword = () => {
        let modalInstance = $uibModal.open({
            template: appChangePasswordView,
            controller: appChangePasswordCtrl,
            controllerAs: 'vm',
            resolve: {}
        });
    };

    $rootScope.regions = !!localStorage.getItem("regions") ? JSON.parse(localStorage.getItem("regions")) : [];
    $scope.regions = $rootScope.regions;
}



// WEBPACK FOOTER //
// ./src/app/views/app.header/AppHeaderCtrl.js